import { useAxiosGet } from "../../../../infrastructure/http";
import { ListTransfersResponse } from "../../../../common/api/Models/ListTransfersResponse";

export function useListTransfers(pageName: string, locationId: number, manual?: boolean) {
	return useAxiosGet<ListTransfersResponse>(
		{
			url: "ListTransfers",
			params: {
				pageName,
				locationId,
			},
		},
		manual ?? false
	);
}
